export const ROLE_SUPERADMIN = 1;
export const ROLE_FACILITY_MANAGER = 2;
export const ROLE_PLANT_CARETAKER = 3;

export const ROLE_NAMES = {
        [ROLE_SUPERADMIN]: 'superadmin',
        [ROLE_FACILITY_MANAGER]: 'Facility manager',
        [ROLE_PLANT_CARETAKER]: 'Plant caretaker',
};
